<template>
  <div>
    <svg class="" width="100%" height="100%" :viewBox="viewBox">
      <g v-for="(bar, index) in bars" :key=index>
        <rect v-for="(part, subidx) in bar.parts" :key="subidx"
          :width="part.width" height="0.95" :x="part.x" :y="index" :fill="part.fill"
          opacity="1">
        </rect>
        <text x="0.2" :y="index + 0.6"
          font-family="sans-serif" font-size="0.4" font-weight="lighter"
          fill="black"
          class="pointer">
          {{ bar.label }}
        </text>
        <text x="9.8" :y="index + 0.6" text-anchor="end"
          font-family="sans-serif" font-size="0.4" font-weight="lighter"
          fill="black">
          {{ bar.sum }}
        </text>
        <rect :width="bar.max" height="0.95" x="0" :y="index" fill="transparent" class="pointer" @click.prevent="barClicked">
        </rect>
      </g>
    </svg>
  </div>
</template>

<script>
import { barColors, barColorsCount } from '@/plugins/colors.js'

export default {
  props: {
    series: {
      type: Array,
      default: function () { return [] }
    }
  },
  computed: {
    viewBox () {
      return `0 0 10 ${this.series.length}`
    },
    max () {
      return this.series.reduce((sum, { values }) => {
        const vssum = values.reduce((s, v) => { return s + v }, 0)
        return vssum > sum ? vssum : sum
      }, 0)
    },
    bars () {
      const max = this.max
      return this.series
        .map((sample) => {
          sample.sum = sample.values.reduce((s, v) => { return s + v }, 0)
          return sample
        })
        .sort((left, right) => {
          return right.sum - left.sum
        })
        .map(({ label, values, sum }) => {
          const sumWidth = sum / max * 10
          let acc = 0
          return {
            label: label,
            sumWidth: sumWidth,
            sum: sum,
            max: max,
            parts: values.map((value, index) => {
              const partWidth = value / max * 10
              acc += partWidth
              return {
                x: acc - partWidth,
                width: partWidth,
                fill: barColors[(index) % barColorsCount]
              }
            })
          }
        })
    }
  },
  methods: {
    barClicked (e) {
      // e.target.setAttribute('fill', 'white')
      // e.target.setAttribute('opacity', '0.8')
    }
  }
}
</script>
